<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="title"
      :visible="visible"
      width="1200px"
      show-close
      top="5vh"
      :close-on-click-modal="false"
      append-to-body
      v-el-dialog-drag
      :before-close="() => $refs.editForm.cancel()"
    >
      <EditForm
        ref="editForm"
        @close="close()"
        @reload="$emit('reload')"
        :disabled="disabled"
        :templateCode="templateCode"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!disabled"
          @click="$refs.editForm.submitSave()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    templateCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    close() {
      this.$emit('reload')
      this.$emit('update:visible', false)
    },
  },
}
</script>
